const config = {
  apiUrl: 'https://mxqqt3cu35.execute-api.eu-central-1.amazonaws.com/prod',
  cognito: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_m3xPOKnRf',
    clientId: '774nu7aj0550d8h1ebgiualdtv',
  },
};
export default config;
